import { render, staticRenderFns } from "./guobu.vue?vue&type=template&id=79bf68c9&scoped=true"
import script from "./guobu.vue?vue&type=script&lang=js"
export * from "./guobu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bf68c9",
  null
  
)

export default component.exports